export default __webpack_public_path__ + "static/media/gallery_sample.0aca3fde.png";